import { render, staticRenderFns } from "./SocialLoginView.vue?vue&type=template&id=f34f5d7a"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerSocialLogin: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerSocialLogin.js').default})
